<ng-template #buttonContent>
  <span class="button-content">
    <ng-content></ng-content>
    <sn-icon *ngIf="icon" class="mat-button__icon">{{ icon }}</sn-icon>
    <sn-button-label *ngIf="label" class="mat-button__label">{{ label }}</sn-button-label>
  </span>
  <ng-template [ngIf]="isLoadingState">
    <mat-spinner diameter="24" [color]="color"></mat-spinner>
  </ng-template>
</ng-template>

<ng-container [ngSwitch]="tagName">
  <button
    *ngSwitchCase="'sn-button'"
    mat-button
    [type]="type"
    [disabled]="isDisabledState"
    [tabIndex]="tabIndex"
  >
    <ng-container *ngTemplateOutlet="buttonContent" [attr.data-testid]="dataTestId"></ng-container>
  </button>

  <button
    *ngSwitchCase="'sn-flat-button'"
    mat-flat-button
    [type]="type"
    [disabled]="isDisabledState"
    [tabIndex]="tabIndex"
  >
    <ng-container *ngTemplateOutlet="buttonContent" [attr.data-testid]="dataTestId"></ng-container>
  </button>

  <button
    *ngSwitchCase="'sn-outline-button'"
    mat-stroked-button
    [type]="type"
    [disabled]="isDisabledState"
    [tabIndex]="tabIndex"
  >
    <ng-container *ngTemplateOutlet="buttonContent" [attr.data-testid]="dataTestId"></ng-container>
  </button>
</ng-container>
